import IAccordion from '../../../models/accordion/IAccordion';
import React from 'react';
import Accordion from '../../atoms/accordion/accordion';

type Props = {
  accordionProps: IAccordion[];
  id?: string;
};

export default function AccordionGroup({ accordionProps, id }: Props) {
  return (
    <div>
      {accordionProps?.map((item) => (
        <Accordion
          id={item.id}
          key={item.id}
          heading={item.heading}
          content={item.content}
          heapIdentifier={item.heapIdentifier}
          isOpened={id === '#' + item.id}
        />
      ))}
    </div>
  );
}
